var $b0fef28529309aa6$exports = {};
$b0fef28529309aa6$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, "\uFF0C").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, "\uFF1A").concat(args.value);
  },
  "colorPicker": "\u6AA2\u8272\u5668",
  "colorSwatch": "\u8272\u7968",
  "transparent": "\u900F\u660E",
  "twoDimensionalSlider": "2D \u6ED1\u687F"
};
export { $b0fef28529309aa6$exports as default };